import {
    Crud,
    HttpClient,
    httpClient,
    RequestOptions,
    QueryParameter,
    HttpClientResponseContent
} from 'lib/HttpClient';
import { ITagGroup } from 'components/location/models/LocationModel';
import { ILocationExportOperationArgs } from '@pepperhq/types-sdk';
import { IPagedCollection } from 'lib/api/paging';
import { v4 as uuid } from 'uuid';
import { ILocationExportOperation } from './models/LocationOperationModel';

class LocationApi extends Crud {
    constructor(client: HttpClient) {
        super(client, process.env.API_SERVER_URL, 'locations', {
            'x-auth-id': process.env.CONSOLE_FIREBASE_PROJECT_ID
        });
    }

    getTagGroups() {
        return this.httpClient.get(`${this.api}/locations/taggroups`);
    }

    deleteTagGroup(tagGroupId: string) {
        return this.httpClient.delete(`${this.api}/locations/taggroups/${tagGroupId}`, {
            skipResponseBody: true,
            skipStringify: true
        });
    }

    updateTagGroup(tagGroup: ITagGroup) {
        return this.httpClient.put(`${this.api}/locations/taggroups`, {
            body: tagGroup
        });
    }

    create(options: RequestOptions) {
        if (!options.headers) {
            options.headers = {};
        }
        options.headers['x-api-version'] = 6; // Override this header
        return this.httpClient.post(`${this.api}/locations`, options);
    }
    getListV9 = (options: RequestOptions) => {
        if (!options.headers) {
            options.headers = {};
        }
        options.headers['x-api-version'] = 9; // Override this header
        return this.getList(options);
    };

    exportLocations(filters?: ILocationExportOperationArgs, nonce?: string) {
        return this.httpClient.post(`${this.api}/locations/exports`, {
            headers: {
                'x-auth-id': process.env.CONSOLE_FIREBASE_PROJECT_ID,
                'x-pepper-req-nonce': nonce || uuid()
            },
            body: { filters }
        });
    }

    getExportOperation(operationId: string): Promise<HttpClientResponseContent<ILocationExportOperation>> {
        return this.httpClient.get(`${this.api}/operations/${operationId}`);
    }

    async downloadExportFile(href: string): Promise<Response> {
        return fetch(`${this.api}${href}`, {
            headers: {
                'x-auth-id': process.env.CONSOLE_FIREBASE_PROJECT_ID,
                Authorization: `Bearer ${this.httpClient.getToken()}`
            }
        });
    }

    getExportOperations(params?: {
        status?: 'PENDING' | 'DONE' | 'ERROR' | 'TIMEOUT';
        nextKey?: string;
    }): Promise<HttpClientResponseContent<IPagedCollection<ILocationExportOperation>>> {
        const queryParameters: QueryParameter[] = [
            { key: 'limit', value: '20' },
            { key: 'sort', value: '-createdAt' }
        ];
        if (params?.status) {
            queryParameters.push({ key: 'status', value: params.status });
        }
        if (params?.nextKey) {
            queryParameters.push({ key: 'startKey', value: params.nextKey });
        }
        return this.httpClient.get(`${this.api}/locations/exports/operations`, {
            queryParameters
        });
    }
}

export const locationApi = new LocationApi(httpClient);
